module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posi"
  }, [_c('div', {
    staticClass: "weui-search-bar weui-search-bar_focusing"
  }, [_c('div', {
    staticClass: "vux-search-mask",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-search-bar__box"
  }, [_c('i', {
    staticClass: "weui-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.serach),
      expression: "serach",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "weui-search-bar__input",
    attrs: {
      "type": "search",
      "autocomplete": "off",
      "placeholder": _vm.flagvalue
    },
    domProps: {
      "value": (_vm.serach)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serach = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "weui-icon-clear",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "javascript:"
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "city",
    staticClass: "city"
  }, [_c('list-view', {
    ref: "list",
    attrs: {
      "data": _vm.singersc
    },
    on: {
      "select": _vm.selectc
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22d90438"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/city.vue
// module id = 386
// module chunks = 1